var productos = function () {
    document.querySelectorAll('.productos--normal .productos__carrusel').forEach(function (carrusel) {
        var lista = carrusel.querySelector('.productos__productos');
        var anterior = carrusel.querySelector('.productos__anterior');
        var siguiente = carrusel.querySelector('.productos__siguiente');
        if (!lista || !anterior || !siguiente) {
            return;
        }
        var rafId = 0;
        var actualizaEstado = function () {
            rafId = 0;
            var maximo = Math.max(0, lista.scrollWidth - lista.clientWidth);
            anterior.disabled = lista.scrollLeft <= 1;
            siguiente.disabled = lista.scrollLeft >= maximo - 1;
        };
        var solicitaActualizacion = function () {
            if (!rafId) {
                rafId = requestAnimationFrame(actualizaEstado);
            }
        };
        var desplaza = function (direccion) {
            var comportamiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches
                ? 'auto'
                : 'smooth';
            var primerProducto = lista.querySelector('.productos__producto');
            var espacio = parseFloat(getComputedStyle(lista).columnGap) || 0;
            var paso = primerProducto
                ? (primerProducto.getBoundingClientRect().width + espacio) * 3
                : lista.clientWidth;
            lista.scrollBy({
                left: direccion * paso,
                behavior: comportamiento
            });
        };
        anterior.addEventListener('click', function () { return desplaza(-1); });
        siguiente.addEventListener('click', function () { return desplaza(1); });
        lista.addEventListener('scroll', solicitaActualizacion, { passive: true });
        window.addEventListener('resize', solicitaActualizacion);
        window.addEventListener('load', solicitaActualizacion, { once: true });
        actualizaEstado();
    });
};
export default productos;
